<template>
  <div class="h-full">
    <TWLoadingSpinner v-if="loading" />
    <PublicPageTemplate v-else>
      <template v-slot:content>
        <PublicPageHeader :title="$t('authentication.2faTitle')" :info="$t('authentication.mfaInfo')" />
        <AuthCodeInput @clear-error="errorMessage = null" @auth-code-changed="setAuthCode" :errorMessage="errorMessage" :successDisplay="successDisplay" />
        <div class="text-center text-sm flex flex-col">
          <hr class="mt-base mb-base" />
          <RouterLink to="/two-factor-authentication/use-recovery-code" data-ec="two_factor_authentication" data-et="use_recovery_code" class="text-black font-normal hover:text-primary">{{ $t('authentication.useRecoveryCode') }}</RouterLink>
          <a href="#" @click="logout" data-ec="two_factor_authentication" data-et="logout" class="text-black font-normal hover:text-primary mt-sm">{{ $t('functional.logOutVerb') }}</a>
        </div>
      </template>
    </PublicPageTemplate>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PublicPageHeader from '@/components/tailwind/publicPages/PublicPageHeader.vue';
import AuthCodeInput from '@/components/tailwind/authentication/AuthCodeInput.vue';
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import { logAmplitudeEvent } from '@/utils/analytics';
import PublicPageTemplate from '@/components/tailwind/publicPages/PublicPageTemplate.vue';

export default {
  name: 'MFA',
  components: {
    PublicPageTemplate,
    PublicPageHeader,
    AuthCodeInput,
    TWLoadingSpinner,
  },
  data() {
    return {
      authCode: null,
      errorMessage: null,
      successDisplay: false,
      loading: false,
    };
  },
  mounted() {
    if (!this.userMfa.authentication_required) {
      this.$router.push('/').catch(() => {});
    }
  },
  computed: {
    ...mapGetters({
      userMfa: 'userMfa/userMfa',
      featureEnabled: 'featureFlags/featureEnabled',
      companyMFA: 'company/companyMFA',
    }),
  },
  methods: {
    ...mapActions({
      logout: 'auth/LOGOUT',
      validateAuthCode: 'userMfa/VALIDATE',
    }),
    authenticate() {
      this.errorMessage = null;
      this.validateAuthCode({ code: this.authCode }).then(() => {
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('authentication.authenticationSuccessMessage'), icon: 'check', type: 'success' }));
        this.successDisplay = true;
        // A quick delay before rerouting in which to display indications of success, otherwise it may feel jarring for the user
        setTimeout(() => this.$router.push('/'), 800);
        logAmplitudeEvent('two_factor_authentication--authentication_successful');
      }).catch((error) => {
        this.errorMessage = error.response.data.message;
        logAmplitudeEvent('two_factor_authentication--authentication_failed');
      });
    },
    setAuthCode(code) {
      this.authCode = code;

      if (this.authCode.length === 6) {
        this.authenticate();
      }
    },
  },
};
</script>
